
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ReadyToStartSection from '../../components/feature/ReadyToStartSection';
import HeroSection from './components/HeroSection';
import ProgramsSection from './components/ProgramsSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProgramsSection />
        <TestimonialsSection />
        <ReadyToStartSection />
      </main>
      <Footer />
    </div>
  );
}
